module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    attrs: {
      "height": _vm.height,
      "border": "",
      "data": _vm.sortedData
    }
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "label"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(scope.row.label))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "align": "right",
      "sortable": "",
      "width": "80px",
      "prop": "percentage"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "percentage"
        }, [_vm._v(_vm._s(scope.row.percentage.toFixed(2)) + "%")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bbf54b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/charts/ProfileTableChart.vue
// module id = 3297
// module chunks = 3